let nav = document.querySelector('nav'),
    hamburger = document.querySelector('#nav-btn'),
    menu = document.querySelector('.nav .menu'),
    infobar = document.querySelector('.infobar')

hamburger.addEventListener("click", function(e) {
  e.preventDefault()

  this.classList.toggle("is-active")
  nav.classList.toggle('active')

}, false);



(function($) {
  'use strict';

  checkNavPosition()
  $(window).scroll(checkNavPosition)
  $(window).resize(checkNavPosition)

  function checkNavPosition(){
    if ($("nav.fade-color").length <= 0) {
      return
    }
    let windowScrollTop = $(window).scrollTop()

    if ($('body').hasClass('home')) {
      if (windowScrollTop >= 35){
          $("nav.fade-color").addClass("sticky")
          $("header section img").addClass("invisible")
      } else {
        $("nav.fade-color").removeClass("sticky")
        $("header section img").removeClass("invisible")
      }

      if (windowScrollTop >= 305) {
        $("nav.fade-color").removeClass("bg-transparent")
      }else{
        $("nav.fade-color").addClass("bg-transparent")
      }
    }
    else {
      if (windowScrollTop >= 35){
          $("nav.fade-color").addClass("sticky")
          $("header section img").addClass("invisible")
          $("nav.fade-color").removeClass("bg-transparent")
      } else {
        $("nav.fade-color").removeClass("sticky")
        $("header section img").removeClass("invisible")
        $("nav.fade-color").addClass("bg-transparent")
      }
    }
  }
}(jQuery));
